import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
type SignedDocumentRequest = {
  documentId: number;
  token: string;
};
const signedDocument = async ({ documentId, token }: SignedDocumentRequest) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/trade-directory/agreement/sign-document`,
      { documentId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};
export default signedDocument;
